import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Row,
  Col,
  Button,
  Divider,
  message,
  Space,
} from "antd";

import {
  formItemLayout,
  tailFormItemLayout,
  smallFormItemLayout,
  smallTailFormItemLayout,
} from "./../../utils/Layouts";
import {
  EditOutlined,
  CloseOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onChange,
} from "../../utils/form_utilities";
import ReportHeading from "../../utils/ReportHeading";
import moment from "moment";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import axios from "axios";
import numberFormat from "../../utils/numberFormat";
import {
  addKeysToArray,
  onWarehouseSearch,
  onStockSearch,
  onBranchSearch,
  getStock,
  getWarehouse,
  onCategorySearch,
} from "../../utils/utilities";
import round from "../../utils/round";
import { sumBy } from "lodash";
import ReactToPrint from "react-to-print";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";

const { Content } = Layout;

const url = "/api/physical-counts/";
const title = "Branch Inventoy Report";

const initialValues = {
  period_covered: [null, null],
  warehouse: null,
  stock: null,
};
export default function BranchInventoryReport() {
  const params = useParams();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const auth = useSelector((state) => state.auth);
  const [state, setState] = useState(initialValues);
  const [content, setContent] = useState("");
  const [options, setOptions] = useState({
    dates: [],
    warehouses: [],
    stocks: [],
  });

  const report = useRef(null);

  const records_column = [
    {
      title: "Date",
      dataIndex: "date",
      render: (date, record) => (
        <span>{date && moment(date).format("MM/DD/YYYY")}</span>
      ),
    },
    {
      title: "Transaction",
      dataIndex: "transaction",
    },
    {
      title: "Warehouse",
      dataIndex: "warehouse",
    },
    {
      title: "Account",
      dataIndex: "account",
    },
    {
      title: "Reference",
      dataIndex: "reference",
    },
    {
      title: "Ext. Ref",
      dataIndex: "external_reference",
    },
    {
      title: "Price",
      dataIndex: "price",
      render: (price) => price && numberFormat(price),
    },
    {
      title: "In",
      dataIndex: "quantity",
      align: "right",
      render: (o, record) => (
        <span>{record.quantity > 0 && `${numberFormat(o)}`}</span>
      ),
    },
    {
      title: "Out",
      dataIndex: "quantity",
      align: "right",
      render: (o, record) => (
        <span>{record.quantity <= 0 && `${numberFormat(Math.abs(o))}`}</span>
      ),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      align: "right",
      render: (o) => <span>{`${numberFormat(o)}`}</span>,
    },
  ];

  const getReport = useCallback(({ ...form_data }) => {
    if (form_data.date && form_data.category?._id && form_data?.branch?._id) {
      const loading = message.loading("Loading...");
      axios
        .post(`${url}/${form_data.report_url}`, form_data)
        .then((response) => {
          loading();
          if (response.data) {
            if (form_data?.is_excel) {
              return window.open(`/public/reports/${response.data.filename}`);
            }
            setContent(response.data?.content || "");
          }
        })
        .catch((err) => {
          loading();
          message.error("There was an error processing your request");
        });
    } else {
      return message.error("All fields are required");
    }
  }, []);

  useEffect(() => {
    if (params?.id && params?.date && params?.warehouse_id) {
      const date = new Date(params.date);
      const period_covered = [moment(date).subtract(1, "month"), moment(date)];

      getStock(params.id).then((stock) => {
        getWarehouse(params.warehouse_id).then((warehouse) => {
          setState((prevState) => ({
            ...prevState,
            warehouse,
            period_covered,
            stock,
          }));
          getReport({
            ...state,
            period_covered,
            stock,
            warehouse,
            report_url: "print-inventory-ledger",
          });
        });
      });
    }
    return () => {};
  }, []);

  return (
    <Content className="content-padding">
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Reports</Breadcrumb.Item>
            <Breadcrumb.Item>{title}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <div style={{ background: "#fff", padding: 24, minHeight: 280 }}>
        <span className="module-title">{title}</span>
        <Divider />
        <Form>
          <Row>
            <Col span={12}>
              <DatePickerFieldGroup
                label="Date"
                name="date"
                value={state.date || null}
                onChange={(value) => {
                  onChange({
                    key: "date",
                    value: value,
                    setState,
                  });
                }}
                error={errors.date}
                formItemLayout={smallFormItemLayout}
              />
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <SelectFieldGroup
                key="1"
                label="Category"
                value={state.category?.name}
                onSearch={(value) =>
                  onCategorySearch({
                    value,
                    options,
                    setOptions,
                    is_menu: false,
                  })
                }
                onFocus={() => {
                  onCategorySearch({
                    value: "",
                    options,
                    setOptions,
                    is_menu: false,
                  });
                }}
                onChange={(index) => {
                  setState((prevState) => ({
                    ...prevState,
                    category: options.categories?.[index] || null,
                  }));
                }}
                error={errors.category?.name}
                formItemLayout={smallFormItemLayout}
                data={options.categories}
                column="name"
              />
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <SelectFieldGroup
                label="Branch"
                value={state.branch?.name}
                onFocus={() => {
                  onBranchSearch({ value: "", setOptions });
                }}
                onSearch={(value) => onBranchSearch({ value, setOptions })}
                onChange={(index) => {
                  const branch = options.branches?.[index] || null;
                  onChange({
                    key: "branch",
                    value: branch,
                    setState,
                  });
                }}
                formItemLayout={smallFormItemLayout}
                data={options.branches}
                column="name"
                error={errors.branch}
              />
            </Col>
          </Row>

          <Row>
            <Col offset={4} span={12}>
              <Form.Item className="field is-grouped">
                <Row gutter={[0, 8]}>
                  <Col span={24}>
                    <Space>
                      <Button
                        onClick={() => {
                          getReport({
                            ...state,
                            report_url: "print-inventory-ledger",
                          });
                        }}
                      >
                        Search Ledger
                      </Button>
                      <Button
                        onClick={() => {
                          getReport({
                            ...state,
                            report_url: "print-inventory",
                          });
                        }}
                      >
                        Search Inventory
                      </Button>
                      <ReactToPrint
                        trigger={() => (
                          <Button
                            type="primary"
                            icon={
                              <span>
                                <i className="fas print"></i>
                              </span>
                            }
                          >
                            Print
                          </Button>
                        )}
                        bodyClass="print"
                        content={() => report.current}
                      />
                    </Space>
                  </Col>
                  <Col span={24}>
                    <Space>
                      <Button
                        onClick={() => {
                          getReport({
                            ...state,
                            is_excel: true,
                            report_url: "print-inventory-ledger",
                          });
                        }}
                      >
                        Download to Excel Ledger
                      </Button>
                      <Button
                        onClick={() => {
                          getReport({
                            ...state,
                            is_excel: true,
                            report_url: "print-inventory",
                          });
                        }}
                      >
                        Download to Excel Inventory
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <div ref={report}>
          <div className="report-heading">
            <ReportHeading />
            <span className="has-text-weight-bold">{title}</span>
            <br />
            {state.date && <div>{moment(state.date).format("MM/DD/YYYY")}</div>}
            {state?.branch?.name} <br />
            Printed By : {auth.user.name} <br />
            Date/Time Printed : {moment().format("LLL")}
          </div>
          <div className="has-text-centered is-size-5 has-text-weight-bold">
            <div>{state.warehouse?.name}</div>
            <div>{state.stock?.name}</div>
          </div>
          <div className="flex-1 is-flex" style={{ height: "500px" }}>
            <textarea
              value={content}
              readOnly
              style={{
                padding: "1rem",
                borderColor: "#c0c0c0",
                fontFamily: "monospace",
              }}
              className="flex-1"
            ></textarea>
          </div>
        </div>
      </div>
    </Content>
  );
}
